const motionQuery = window.matchMedia('(prefers-reduced-motion: no-preference)');

if (motionQuery.matches && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('landing-revealed');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -4% 0px', threshold: 0.1 }
  );

  const add = (root, selector, direction, stagger = 0) => {
    root.querySelectorAll(selector).forEach((element, index) => {
      if (element.hasAttribute('data-landing-reveal')) {
        if (!element.classList.contains('landing-revealed')) observer.observe(element);
        return;
      }
      element.dataset.landingReveal = direction;
      if (stagger) element.style.setProperty('--landing-reveal-delay', `${index * stagger}ms`);
      observer.observe(element);
    });
  };

  const init = (root = document) => {
    add(root, '.landing-features__item', 'up', 170);
    root.querySelectorAll('.landing-feature-row').forEach((row) => {
      const imageLeft = row.querySelector('.landing-feature-row__content--image-left');
      add(row, '.landing-feature-row__panel', imageLeft ? 'left' : 'right');
      add(row, '.landing-feature-row__text', 'up');
    });
    add(root, '.landing-logos__heading, .landing-logos__description', 'up');
    add(root, '.landing-logos__card', 'up', 90);
    add(root, '.landing-reviews__header', 'up');
    add(root, '.landing-reviews__card', 'up', 100);
    add(
      root,
      '.landing-ways h2, .landing-kit__heading, .landing-app__text, .landing-cta h2, .landing-cta__proof, .landing-cta__button',
      'up'
    );
    add(root, '.landing-ways__card, .landing-kit__list li, .landing-app__list li', 'up', 100);
    add(root, '.landing-kit__panel', 'left');
    add(root, '.landing-app__panel, .landing-cta__mat', 'right');
    document.body.classList.add('landing-motion-ready');
  };

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  motionQuery.addEventListener('change', () => {
    if (!motionQuery.matches) {
      observer.disconnect();
      document.body.classList.remove('landing-motion-ready');
    } else {
      init();
    }
  });
}
